import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalculate = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.5 15.5H7V13.5H9V12H7V10H5.5V12H3.5V13.5H5.5V15.5ZM10.5 14.75H15.5V13.25H10.5V14.75ZM10.5 12.25H15.5V10.75H10.5V12.25ZM11.6 8.45L13 7.05L14.4 8.45L15.45 7.4L14.05 5.95L15.45 4.55L14.4 3.5L13 4.9L11.6 3.5L10.55 4.55L11.95 5.95L10.55 7.4L11.6 8.45ZM3.75 6.7H8.75V5.2H3.75V6.7ZM2.5 18.5C1.95 18.5 1.47917 18.3042 1.0875 17.9125C0.695833 17.5208 0.5 17.05 0.5 16.5V2.5C0.5 1.95 0.695833 1.47917 1.0875 1.0875C1.47917 0.695833 1.95 0.5 2.5 0.5H16.5C17.05 0.5 17.5208 0.695833 17.9125 1.0875C18.3042 1.47917 18.5 1.95 18.5 2.5V16.5C18.5 17.05 18.3042 17.5208 17.9125 17.9125C17.5208 18.3042 17.05 18.5 16.5 18.5H2.5ZM2.5 16.5H16.5V2.5H2.5V16.5Z",
		fill: "currentColor"
	})
});
export default SvgCalculate;
